import { getTripStopIds } from './model.js'

/**
 * 고색역 10:00 특수편 메타데이터.
 * 정류장 좌표와 path는 여기서 관리하지 않고 SHUTTLE_STOPS + shuttleTripModel에서 합성한다.
 */
export const GOSAEK_ROUTES = [
  {
    id: 'gosaek_1000_campus_loop',
    routeKey: 'gosaek_to_school',
    label: '10:00 순환',
    displayTime: '10:00 순환',
    fullLabel: '고색역 10:00 순환',
    time: '10:00',
    departureTime: '10:00',
    routeName: '고색역 → 수원대',
    startName: '고색역',
    endName: '인문대 승차',
    durationText: '약 30분',
    durationSec: 30 * 60,
    direction: 'inbound',
    summary: '교내 정류장 순환',
    notice: '이 시간대는 학교 도착 후 교내 순환까지 이어서 운행합니다.',
    tripVariant: 'campus_loop',
    stopIds: getTripStopIds('gosaek_to_school', '10:00', [], { variant: 'campus_loop' }),
  },
]
